/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { TutorAIUpdateTokenLimitViewModel } from "../types/TutorAIUpdateTokenLimitViewModel.ts";

export const tutorAIUpdateTokenLimitViewModelSchema = z.object({
  dailyLimit: z.optional(z.number().int()),
  weeklyLimit: z.optional(z.number().int()),
  monthlyLimit: z.optional(z.number().int()),
  enabled: z.optional(z.boolean()),
}) as unknown as ToZod<TutorAIUpdateTokenLimitViewModel>;
